import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Tag } from '../extra/Tag'
import { AuthorTag } from '../extra/AuthorTag'
import { format } from 'date-fns'
import { articleType } from '../article'

type PreviewArticleCardProps = articleType & {
  route: string
}

export const PreviewArticleCard = (props: PreviewArticleCardProps) => {
  const navigate = useNavigate()

  return (
    <div onClick={() => navigate(props.route)}>
      <div className='flex flex-col w-[330px] h-full cursor-pointer shadow-lg rounded-xl'>
        <div className='relative'>
          <img
            className='h-[191px] w-full rounded-t-xl'
            src={`${props?.cover_image}`}
          />

          <div className='absolute top-4 left-4 bg-white text-[#122D5C] text-xs py-[4px] px-[8px] rounded-xl font-medium'>
            {format(new Date(props?.publish_date), 'do MMMM yyyy')}
          </div>
        </div>

        <div className='flex flex-col h-full p-5'>
          <div>
            <h5 className='font-medium tracking-wide text-[#101828]'>
              {props?.title}
            </h5>

            <p className='line-clamp-2 text-xs text-[#6E7785]'>
              {props?.summary}
            </p>
          </div>

          <div className='flex flex-col justify-end h-full'>
            <div className='flex flex-wrap gap-2 pt-3'>
              {props?.tags?.map((tag, idx) => (
                <Tag
                  key={tag + idx}
                  className='text-xs px-[6px] py-[2px]'
                  text={tag}
                />
              ))}
            </div>

            <hr className='my-[10px]' />

            <AuthorTag
              author={props.author}
              userNameClassName='text-[10px]'
              occupationClassName='text-[8px]'
              tagClassName='bg-[#EBFBFF]'
            />
          </div>
        </div>
      </div>
    </div>
  )
}
